import { createFileRoute } from "@tanstack/react-router";
import EnumConfigPage from "./-enumConfig";

export const Route = createFileRoute("/_layout/system/enumConfig")({
  staticData: {
    menuLabel: "枚举配置",
    showInMenu: true,
    menuGroup: "/system",
    menuOrder: 6,
  },
  component: EnumConfigPage,
});
